

exports.__esModule = true;
var onetouch = {
    signup_onetouch_variant1_graphic: 'signUpVariantOne',
    signup_onetouch_variant2: 'signUpVariantTwo',
    signup_onetouch_control: 'control'
};

var singlepassword = {
    singlepassword_test: 'xoon_single_password_test'
};

var xoon_optional_signup_content_change = {
    xoon_optional_signup_content_change_gb_test: {
        subTitle: 'common.createPayPalPropTest1',
        yesCreateAccount: 'common.yesCreateAccountTest1'
    },
    xoon_optional_signup_content_change_test1: {
        title: 'common.getBenefitsLine1Test1',
        subTitle: 'common.createPayPalPropTest1'
    },
    xoon_optional_signup_content_change_test2: {
        title: 'common.getBenefitsLine1Test1',
        subTitle: 'common.createPayPalPropTest2'
    },
    xoon_optional_signup_content_change_test3: {
        title: 'common.getBenefitsLine1Test2',
        subTitle: 'common.createPayPalPropTest3'
    },
    xoon_optional_signup_content_change_test4: {
        title: 'common.getBenefitsLine1Test2',
        subTitle: 'common.createPayPalPropTest4'
    }
};

var frs_wps_optional = {
    frs_wps_optional_treatment1: {
        title: 'signup.createPayPalAccountFRSLine1Variant1',
        subTitle: 'signup.createPayPalAccountFRSLine2Variant1'
    },
    frs_wps_optional_treatment2: {
        title: 'signup.createPayPalAccountFRSLine1Variant2',
        subTitle: 'signup.createPayPalAccountFRSLine2Variant2'
    },
    frs_wps_optional_treatment3: {
        title: 'signup.createPayPalAccountFRSLine1Variant3',
        subTitle: 'signup.createPayPalAccountFRSLine2Variant1'
    }
};

var frs_ec_optional = {
    frs_ec_optional_treatment1: {
        title: 'signup.createPayPalAccountFRSLine1Variant4',
        subTitle: 'signup.createPayPalAccountFRSLine2Variant1'
    },
    frs_ec_optional_treatment2: {
        title: 'signup.createPayPalAccountFRSLine1Variant5',
        subTitle: 'signup.createPayPalAccountFRSLine2Variant2'
    },
    frs_ec_optional_treatment3: {
        title: 'signup.createPayPalAccountFRSLine1Variant6',
        subTitle: 'signup.createPayPalAccountFRSLine2Variant1'
    }
};

var frs_ec_forced = {
    frs_ec_forced_treatment1: {
        title: 'signup.createPayPalAccountFRSLine1Variant7',
        subTitle: 'signup.createPayPalAccountFRSLine2Variant1'
    },
    frs_ec_forced_treatment2: {
        title: 'signup.createPayPalAccountFRSLine1Variant8',
        subTitle: 'signup.createPayPalAccountFRSLine2Variant2'
    },
    frs_ec_forced_treatment3: {
        title: 'signup.createPayPalAccountFRSLine1Variant9',
        subTitle: 'signup.createPayPalAccountFRSLine2Variant1'
    }
};

var frs_applicable_treatments = {
    wps_optional: ['frs_wps_optional_treatment1', 'frs_wps_optional_treatment2', 'frs_wps_optional_treatment3'],
    ec_optional: ['frs_ec_optional_treatment1', 'frs_ec_optional_treatment2', 'frs_ec_optional_treatment3'],
    ec_forced: ['frs_ec_forced_treatment1', 'frs_ec_forced_treatment2', 'frs_ec_forced_treatment3']
};

exports['default'] = {
    test: {
        onetouch: onetouch,
        singlepassword: singlepassword,
        xoon_optional_signup_content_change: xoon_optional_signup_content_change,
        frs_wps_optional: frs_wps_optional,
        frs_ec_optional: frs_ec_optional,
        frs_ec_forced: frs_ec_forced,
        frs_applicable_treatments: frs_applicable_treatments
    }
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./components/xo-guest-components/src/guest/constants/pxpExperimentConstants.js
// module id = ./components/xo-guest-components/src/guest/constants/pxpExperimentConstants.js
// module chunks = 1